export default {
  message: {
    defaultMessage: 'Your global privacy preferences have been applied.',
    id: 'gpc.notification.message',
  },

  closeAriaLabel: {
    defaultMessage: 'Close notification',
    id: 'gpc.notification.closeAriaLabel',
  },
}
